// Simple module-level bridge between LessonPlanner and its drawer components.
// Needed because drawers are rendered outside LessonPlanner's component tree.
const lessonPlannerEventBus = {
    currentContent: [],  // concept IDs already in the lesson
    addHandler: null,    // set by LessonPlanner before opening AddLessonContentDrawer
    scheduleId: null,    // set by LessonPlanner before opening LessonPlannerReportDrawer
};

export default lessonPlannerEventBus;
